// extracted by mini-css-extract-plugin
export default {"container":"index_container__TxM-I","tabs":"index_tabs__N7s0q","tabsTitle":"index_tabsTitle__fPjng","content":"index_content__5tC3G"};